import { Button } from "react-bootstrap";
import type { LiveTimeline } from "../lib/live-history";

export function LiveHistoryControls({
  label,
  history,
  disabled,
  onMove
}: {
  label: string;
  history: LiveTimeline;
  disabled: boolean;
  onMove: (step: -1 | 1) => void;
}) {
  return (
    <div
      className="d-flex align-items-center gap-2"
      role="group"
      aria-label={`Live history for ${label}`}
    >
      <Button
        type="button"
        size="sm"
        variant="outline-light"
        aria-label={`Undo ${label}`}
        disabled={disabled || history.cursor === 0}
        onClick={() => onMove(-1)}
      >
        ← Undo
      </Button>
      <span className="small text-secondary" aria-label={`${label} history position`}>
        {history.cursor + 1} of {history.entries.length}
      </span>
      <Button
        type="button"
        size="sm"
        variant="outline-light"
        aria-label={`Redo ${label}`}
        disabled={disabled || history.cursor === history.entries.length - 1}
        onClick={() => onMove(1)}
      >
        Redo →
      </Button>
    </div>
  );
}
